import { Badge, Box, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { useAuth } from "../../../providers/AuthProvider";
import { useReadOrganization } from "../../../services/api/organization/queries/useReadOrganization";

const UserSettings = () => {
  const { userProfile } = useAuth();
  const { data: dataOrganization } = useReadOrganization(
    userProfile.organization_id
  );

  return (
    <Box w="full" h="full">
      <Stack
        spacing={8}
        maxW={"xl"}
        borderWidth="1px"
        mx="auto"
        py={8}
        px={8}
        rounded="md"
      >
        <Stack spacing={1}>
          <Text textStyle={"label"}>Name</Text>
          <Text>{`${userProfile.first_name} ${userProfile.last_name}`}</Text>
        </Stack>
        <Stack spacing={1}>
          <Text textStyle={"label"}>Email</Text>
          <Text>{userProfile.email}</Text>
        </Stack>
        <Stack spacing={1}>
          <Text textStyle={"label"}>Organization</Text>
          <Text>{dataOrganization?.name}</Text>
          {userProfile.is_admin && (
            <Box>
              <Badge colorScheme={"cyan"}>Admin</Badge>
            </Box>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default UserSettings;
